export const VAT_CONFIG = {
    ALB: { hint: 'Numri i TVSH-së', pattern: '' },
    AND: { hint: 'Número de IVA', pattern: '' },
    ARE: { hint: 'رقم ضريبة القيمة المضافة', pattern: '' },
    AUT: { hint: 'Umsatzsteuer-Identifikationsnummer', pattern: '^ATU\\d{8}$' },
    BEL: { hint: 'Numéro de TVA', pattern: '^BE\\d{10}$' },
    BGR: { hint: 'ДДС номер', pattern: '^BG\\d{9,10}$' },
    BIH: { hint: 'PDV broj', pattern: '' },
    CHE: { hint: 'MWST-Nummer', pattern: '^CHE\\d{3}.\\d{3}.\\d{3}(?:MWST|TVA|IVA)?$' },
    CYP: { hint: 'Αριθμός ΦΠΑ', pattern: '^CY\\d{8}[a-z]{1}$' },
    CZE: { hint: 'IČ DPH', pattern: '^CZ\\d{8,10}$' },
    DEU: { hint: 'Umsatzsteuer-Identifikationsnummer', pattern: '^DE\\w{9,12}$' },
    DNK: { hint: 'Momsnummer', pattern: '^DK\\d{8}$' },
    DZA: { hint: 'Numéro de TVA', pattern: '' },
    EGY: { hint: 'رقم ضريبة القيمة المضافة', pattern: '' },
    ESP: { hint: 'Número de IVA', pattern: '^ES([a-z]|\\d)\\d{7}([a-z]|\\d)$' },
    EST: { hint: 'Käibemaksukohustuslase number', pattern: '^EE\\d{9}$' },
    FIN: { hint: 'ALV-numero', pattern: '^FI\\d{8}$' },
    FRA: { hint: 'Numéro de TVA', pattern: '^FR([a-zA-Z]|\\d){2}\\d{9}$' },
    GBR: { hint: 'VAT Number', pattern: '^GB(\\d{2}|[a-z]{2})\\d{6}$' },
    GRC: { hint: 'Αριθμός ΦΠΑ', pattern: '^EL\\d{9}$' },
    HRV: { hint: 'PDV ID', pattern: '^HR\\d{11}$' },
    HUN: { hint: 'ÁFA azonosító szám', pattern: '^(\\d{8}(?:-\\d-\\d\\d)?|\\d{11})$' },
    IRL: { hint: 'VAT Identification Number', pattern: '^IE\\d{1}([a-z]|\\d)\\d{4,5}([a-z]|\\d){1}[a-z]{1}$' },
    ITA: { hint: 'Partita IVA', pattern: '^IT\\d{11}$' },
    JOR: { hint: 'رقم ضريبة القيمة المضافة', pattern: '' },
    LIE: { hint: 'MWST-Nummer', pattern: '^CHE\\d{3}.\\d{3}.\\d{3}(?:MWST|TVA|IVA)?$' },
    LTU: { hint: 'PVM mokėtojo kodas', pattern: '^LT(\\d{9}|\\d{12})$' },
    LUX: { hint: 'Numéro de TVA', pattern: '^LU\\d{8}$' },
    LVA: { hint: 'PVN maksātāja numurs', pattern: '^LV\\d{11}$' },
    MAR: { hint: 'Numéro de TVA', pattern: '' },
    MCO: { hint: 'Numéro de TVA', pattern: '' },
    MKD: { hint: 'ДДВ број', pattern: '' },
    MLT: { hint: 'VAT Number', pattern: '^MT\\d{8}$' },
    MNE: { hint: 'PDV broj', pattern: '' },
    NLD: { hint: 'BTW-nummer', pattern: '^NL(\\d{9}B(\\d{2}|O2)|\\d{8})$' },
    NOR: { hint: 'MVA-nummer', pattern: '' },
    POL: { hint: 'Numer VAT', pattern: '^\\d{10}$' },
    PRT: { hint: 'Número de IVA', pattern: '^PT\\d{9}$' },
    QAT: { hint: 'رقم ضريبة القيمة المضافة', pattern: '' },
    ROU: { hint: 'Număr de TVA', pattern: '^RO\\d{2,10}$' },
    SRB: { hint: 'PDV broj', pattern: '' },
    SVK: { hint: 'IČ DPH', pattern: '^SK\\d{10}$' },
    SVN: { hint: 'ID za DDV', pattern: '^SI\\d{8}$' },
    SWE: { hint: 'Momsregistreringsnummer', pattern: '^SE\\d{12}$' },
    TUR: { hint: 'KDV numarası', pattern: '' },
    UKR: { hint: 'ІПН для ПДВ', pattern: '' },
};
